import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	style: {
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .752,
			y: 3.75,
			width: 22.5,
			height: 19.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .752,
			y1: 9.75,
			x2: 23.252,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6.752,
			y1: 6,
			x2: 6.752,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17.252,
			y1: 6,
			x2: 17.252,
			y2: .75
		})
	]
});
export default SvgCalendar;
